// extracted by mini-css-extract-plugin
export default {"list":"coverage-tip-modal-module__list--ido"};